var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReducaoCustos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reducao-custos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reducao-custos_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.3,129.4V33.5h-24.4v96h-8.1V66H73.4v63.4h-8.1V94.2H40.9v35.2h-7.5v8.1h104.1v-8.1H130.3z M49,129.4v-27 h8.1v27H49z M81.5,74.1h8.1v55.3h-8.1V74.1z M114.1,129.4V41.6h8.1v87.8H114.1z M44.3,76.7c-2.4-2.4-3.7-5.5-3.7-8.7v-1.6h8.1V68 c0,2.3,2,4.2,4.3,4.2s4.3-2,4.3-4.3c0-1.8-2-3-6.1-5.1h-0.1c-3.2-1.7-9.2-4.9-9.2-12.5c0-4.6,3-8.6,7.1-10.2v-6.6h8.1v6.6 c1.4,0.5,2.6,1.3,3.7,2.3c2.2,2,3.4,4.8,3.4,7.8v1h-8.1v-1c0-1.7-1.6-2.7-3-2.7c-1.7,0-3,1.3-3,2.8c0,2.2,1,3.3,4.9,5.3h0.1 c2.3,1.2,4.6,2.4,6.5,4.1c2.6,2.3,3.9,5.1,3.9,8.3c0,3.3-1.3,6.4-3.6,8.8c-1.4,1.4-3,2.4-4.7,3v6.6h-8.1v-6.6 C47.3,79.1,45.7,78.1,44.3,76.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReducaoCustos);
export default __webpack_public_path__ + "static/media/reducao-custos.4ad4029a86dc26eb9160cb350477b956.svg";
export { ForwardRef as ReactComponent };